var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImplementationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1140 l0 -880 1120 0 1120 0 0 880 0 880 -1120 0 -1120 0 0 -880z m210 810 c11 -11 20 -29 20 -40 0 -26 -34 -60 -62 -60 -53 0 -79 74 -36 104 30 21 54 20 78 -4z m160 0 c11 -11 20 -29 20 -40 0 -26 -34 -60 -62 -60 -53 0 -79 74 -36 104 30 21 54 20 78 -4z m160 0 c24 -24 25 -48 4 -78 -29 -42 -104 -18 -104 35 0 28 33 63 60 63 11 0 29 -9 40 -20z m1640 -880 l0 -730 -1050 0 -1050 0 0 730 0 730 1050 0 1050 0 0 -730z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227 1393 c-31 -61 -308 -695 -305 -698 6 -6 81 -35 83 -33 6 7 315 710 315 717 0 6 -63 41 -75 41 -3 0 -11 -12 -18 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 1222 c-172 -107 -205 -131 -205 -151 0 -20 32 -42 209 -147 l210 -123 24 40 c13 22 22 42 20 43 -1 2 -74 44 -160 95 -87 51 -158 94 -158 96 0 2 69 45 153 96 83 50 156 95 160 99 8 7 -30 80 -41 80 -4 0 -99 -58 -212 -128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452 1314 c-13 -20 -20 -40 -15 -44 4 -4 77 -49 161 -100 84 -51 150 -96 145 -100 -4 -5 -75 -48 -158 -96 -82 -48 -152 -88 -153 -90 -2 -1 7 -21 20 -43 l24 -40 210 123 c177 105 209 127 209 147 0 20 -33 44 -205 151 -113 70 -207 128 -210 128 -3 0 -16 -16 -28 -36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplementationIcon);
export default __webpack_public_path__ + "static/media/implementation-icon.5f3c80f4b5b6176ce7731b4a4a597f5b.svg";
export { ForwardRef as ReactComponent };